export default __webpack_public_path__ + "static/media/unlaunch.b703c945.svg";